$(document).ready(function () {

    if ($('#users_table').length) {

        let url = window.location.origin + '/users/get';

        setTimeout(function () {
            users_table();
        }, 500);

        function users_table() {
            const dataTable = $('#users_table').dataTable({
                "processing": true,
                "serverSide": true,
                "ajax": url,
                "columns": [
                    {data: 'id'},
                    {data: 'nombre'},
                    {data: 'email'},
                    //{data: 'user_sucursal.name', name: 'sucursal_name',orderable: true},
                    {data: 'sucursal_name', orderable: false},// se desactiva por que no funciona por la relacion investigar despues
                    {data: 'area'},
                    {data: 'status'},
                ],
                //"order": [[0, 'asc']],
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "render": function (data, type, row, meta) {
                            return "";
                        }
                    },
                    {
                        "targets": 5,
                        "render": function (data, type, row, meta) {
                            if (row.status === 1) {
                                return "<span class='badge badge-success' style='width: 30px; height: 30px; display: inline-block;'><i class='fa fa-2x fa-check' aria-hidden='true'></i></span>";
                            } else {
                                return "<span class='badge badge-danger' style='width: 30px; height: 30px; display: inline-block;'><i class='fa fa-2x fa-times' aria-hidden='true'></i></span>";
                            }
                        },
                        "className": "text-center"
                    },
                    {
                        "targets": 6,
                        "render": function (data, type, row, meta) {
                            //if (row.id === 1) return "No Aplica";
                            let btn = "";

                            if (row.status === 1) btn = "<button type='button' class='btn btn-danger btn-sm remove-users' data-toggle='tooltip' data-placement='top' title='Desactivar usuario' data-user='" + row + "'><i class='fas fa-trash'></i></button> ";
                            else btn = "<button type='button' class='btn btn-success btn-sm activate-users' data-toggle='tooltip' data-placement='top' title='Activar usuario' data-user='" + row + "' ><i class='fa fa-check'></i></button> ";

                            return "<button type='button' class='btn btn-primary btn-sm edit-users' data-toggle='tooltip' data-placement='top' title='Editar usuario' data-user='" + row + "'><i class='fas fa-edit'></i></button> "
                                + "<button type='button' class='btn btn-primary btn-sm permissions-users' data-toggle='tooltip' data-placement='top' title='Otorgar/Denegar permisos' data-user='" + row + "'><i class='fas fa-bars'></i></button> "
                                + "<button type='button' class='btn btn-primary btn-sm password-users' data-toggle='tooltip' data-placement='top' title='Cambiar contraseña' data-user='" + row + "'><i class='fas fa-lock'></i></button> "
                                + btn
                            /*
                            if (row.status === 1) {
                                return "<button type='button' class='btn btn-primary btn-sm edit-users' data-toggle='tooltip' data-placement='top' title='Editar usuario' data-user='" + row + "'><i class='fas fa-edit'></i></button> "
                                    + "<button type='button' class='btn btn-primary btn-sm permissions-users' data-toggle='tooltip' data-placement='top' title='Otorgar/Denegar permisos' data-user='" + row + "'><i class='fas fa-bars'></i></button> "
                                    + "<button type='button' class='btn btn-primary btn-sm password-users' data-toggle='tooltip' data-placement='top' title='Cambiar contraseña' data-user='" + row + "'><i class='fas fa-lock'></i></button> "
                                    + "<button type='button' class='btn btn-danger btn-sm remove-users' data-user='" + row + "'><i class='fas fa-trash'></i></button> ";
                            } else {
                                return "<button type='button' class='btn btn-primary btn-sm activate-users' data-user='" + row + "' ><i class='fa fa-check'></i></button> ";
                            }
                            */
                        }
                    }],
                "language": {
                    "url": window.location.origin + "/json/Spanish.json"
                },
            });

            dataTable.on('draw.dt', function () {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            });

            $('#users_table tbody').on('click', '.edit-users', function (e) {
                e.preventDefault();
                let table = $("#users_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                $.ajax({
                    url: window.location.origin + '/users/' + rowData.id + '/edit',
                    type: 'GET',
                })
                    .done(function (response) {
                        $('#div_modal_users').html(response);
                        $('.chosen-select').chosen({width: '100%'});
                        /*$('.dropify').dropify({
                            messages: {
                                'default': 'Arrastre y suelte un archivo o haga clic',
                                'replace': 'Arrastra y suelta o haz clic para reemplazar',
                                'remove': 'Eliminar',
                                'error': 'Vaya, sucedió algo mal'
                            }
                        });*/
                        $('#modal-users').modal("show");

                    })
                    .fail(function (jqXHR, textStatus) {
                        console.log(jqXHR);
                        alert("Disculpe, existió un problema");
                    });
            });

            $('#users_table tbody').on('click', '.permissions-users', function (e) {
                e.preventDefault();
                let table = $("#users_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                alert('permisos')

                /*
                $.ajax({
                    url: window.location.origin + '/users/' + rowData.id + '/edit',
                    type: 'GET',
                })
                    .done(function (response) {
                        document.getElementById('div_modal_users').innerHTML = response;
                        $('.chosen-select').chosen({width: '100%'});

                        $('#modal-users').modal("show")
                    })
                    .fail(function (jqXHR, textStatus) {
                        console.log(jqXHR);
                        alert("Disculpe, existió un problema");
                    });
                 */


            });

            $('#users_table tbody').on('click', '.remove-users', function (e) {
                e.preventDefault();
                let table = $("#users_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();
                Swal
                    .fire({
                        title: "Desactivar al usuario " + rowData.nombre,
                        text: "¿Desactivar?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: "Sí, Desactivar",
                        cancelButtonText: "Cancelar",
                    })
                    .then(resultado => {
                        if (resultado.value) {
                            let url = window.location.origin + '/users/' + rowData.id;
                            $.ajax({
                                url: url,
                                type: 'DELETE',
                                headers: {
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                }
                            })
                                .done(function (response) {
                                    Swal.fire('Desactivado', ' Se ha desactivado el usuario.', 'success')
                                        .then(() => {
                                            let url = window.location.origin + '/users/get';
                                            $('#users_table').DataTable().ajax.url(url).load();
                                        });
                                })
                                .fail(function (jqXHR, textStatus) {
                                    console.log(jqXHR);
                                    alert("Disculpe, existió un problema");
                                });
                        }
                    });
            });

            $('#users_table tbody').on('click', '.password-users', function (e) {
                e.preventDefault();
                let table = $("#users_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                $.ajax({
                    url: window.location.origin + '/users/change_password/' + rowData.id,
                    type: 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                })
                    .done(function (response) {
                        //document.getElementById('div_modal_users').innerHTML = response;
                        $('#div_modal_users').html(response);
                        $('#modal-users').modal("show");
                    })
                    .fail(function (jqXHR, textStatus) {
                        console.log(jqXHR);
                        alert("Disculpe, existió un problema");
                    });
            });

            $('#users_table tbody').on('click', '.activate-users', function (e) {
                e.preventDefault();
                let table = $("#users_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                Swal
                    .fire({
                        title: "Reactivar al usuario " + rowData.nombre,
                        text: "¿Activar?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: "Sí, activarlo",
                        cancelButtonText: "Cancelar",
                    })
                    .then(resultado => {
                        if (resultado.value) {
                            $.ajax({
                                url: window.location.origin + '/users/reactivate',
                                type: 'POST',
                                data: {
                                    id: rowData.id
                                },
                                headers: {
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                }
                            })
                                .done(function (response) {
                                    Swal.fire('Activado', 'Se ha reactivado el usuario.', 'success')
                                        .then(() => {
                                            let url = window.location.origin + '/users/get';
                                            $('#users_table').DataTable().ajax.url(url).load();
                                        });
                                })
                                .fail(function (jqXHR, textStatus) {
                                    console.log(jqXHR);
                                    alert("Disculpe, existió un problema");
                                });
                        }
                    });
            });
        }

        $(".add_users").on('click', function () {

            $.ajax({
                url: window.location.origin + '/users/create',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_users').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});

                    /*$('.dropify').dropify({
                        messages: {
                            'default': 'Arrastre y suelte un archivo o haga clic',
                            'replace': 'Arrastra y suelta o haz clic para reemplazar',
                            'remove': 'Eliminar',
                            'error': 'Vaya, sucedió algo mal'
                        }
                    });*/

                    $('#modal-users').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });

        })

        $(document).on('click', '#send_users', function (event) {
            event.preventDefault();

            let url = window.location.origin + '/users';
            let formData = new FormData();

            /*
            if ($("#logo").length > 0) {
                let files = document.getElementById('logo').files[0];
                formData.append('logo', files);
            }
            */

            formData.append('nombre', $("#nombre").val());
            formData.append('email', $("#correo").val());
            formData.append('pass', $("#pass").val());
            formData.append('sucursal_id', $("#sucursal_id").val());
            formData.append('area', $("#area").val());
            formData.append('profile', $("#profile").val());

            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: formData,
                url: url,
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Agregado', ' Se agrego el usuario correctamente', 'success')
                        .then(() => {
                            $('#modal-users').modal("hide");
                            let url = window.location.origin + '/users/get';
                            $('#users_table').DataTable().ajax.url(url).load();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class=''>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

        $(document).on('click', '#send_users_password', function (event) {
            event.preventDefault();

            let url = window.location.origin + '/users/save/password';
            let formData = new FormData();

            formData.append('id', $("#id").val());
            formData.append('pass', $("#pass").val());
            formData.append('pass2', $("#pass2").val());

            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: formData,
                url: url,
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Actualizado', 'Se actualizo la contraseña correctamente', 'success')
                        .then(() => {
                            $('#modal-users').modal("hide");
                            //let url = window.location.origin + '/users/get';
                            //$('#users_table').DataTable().ajax.url(url).load();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class=''>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

        $(document).on('click', '#send_users_update', function (event) {

            event.preventDefault();
            let id = $("#id").val();
            let url = window.location.origin + '/users/' + id;
            let formData = new FormData();

            if ($("#logo").length > 0) {
                let files = document.getElementById('logo').files[0];
                formData.append('logo', files);
            }
            formData.append('id', $("#id").val());
            formData.append('nombre', $("#nombre").val());
            formData.append('email', $("#correo").val());
            formData.append('sucursal_id', $("#sucursal_id").val());
            formData.append('area', $("#area").val());
            formData.append('profile', $("#profile").val());
            formData.append('_method', 'PUT'); //requerido para enviar el archivo se tiene que usar post en ajax

            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: formData,
                url: url,
                //type: 'PUT',
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {

                    if (typeof response['status'] !== 'undefined') {
                        Swal.fire('Advertencia', response['message'], 'info')
                            .then(() => {
                                location.reload();
                            });
                    } else {
                        Swal.fire('Actualizado', 'Se actualizo el usuario correctamente', 'success')
                            .then(() => {
                                $('#modal-users').modal("hide");
                                let url = window.location.origin + '/users/get';
                                $('#users_table').DataTable().ajax.url(url).load();
                            });
                    }

                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class=''>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

    }


    $(document).on('submit', '#form_tokenization_process', function (e) {
        e.preventDefault();
        let pass = $("#llave").val();


        $.ajax({
            url: window.location.origin + '/tokenization_process',
            type: 'POST',
            data: {
                pass: pass,
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                Swal.fire(response['title'], response['message'], response['icon']);
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    })

});

